import { Bar } from 'victory';
import { FC, useCallback } from 'react';

interface Props {
    x?: number;
    width: number;
}

export const SideStrokedBar: FC<Readonly<Props>> = (props: Props) => {
    const { x, width } = props;
    const getProps = useCallback(
        (w: number = 0) => ({
            x1: (x ?? 0) + w,
            x2: (x ?? 0) + w,
            y1: 280,
            y2: 15,
            strokeDasharray: 5,
        }),
        [x],
    );

    return (
        <g>
            <Bar {...props} />

            <line {...getProps()} />

            <line {...getProps(width)} />
        </g>
    );
};

export default SideStrokedBar;
